/* HDMC Rewards page. Talks to the rewards service through the store's App Proxy (/apps/rewards),
   which Shopify signs and which carries the logged-in customer id. No tokens in the page. */
(function () {
  'use strict';
  var root = document.querySelector('[data-rewards]');
  if (!root) return;
  var API = root.getAttribute('data-api') || '/apps/rewards';
  var LOGGED_IN = root.getAttribute('data-logged-in') === 'true';
  var LOGIN = root.getAttribute('data-login') || '/account/login';
  var REGISTER = root.getAttribute('data-register') || '/account/register';
  var RETURN = root.getAttribute('data-return') || location.pathname;
  var HOST = root.getAttribute('data-host') || 'page';
  // Referral code: ?ref=CODE on the link a friend shared. Remembered in a 30-day cookie so a friend
  // who browses first and comes back to sign up later still sees the claim box (LAUNCH P10).
  var REF_COOKIE = 'rw_ref';
  function readCookie(name) {
    try {
      var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) { return ''; }
  }
  function writeCookie(name, value, days) {
    try {
      var exp = new Date(Date.now() + days * 864e5).toUTCString();
      document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + exp + '; path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
    } catch (e) {}
  }
  var REF = (function () {
    var fromUrl = '';
    try { fromUrl = (new URLSearchParams(location.search).get('ref') || '').trim().toUpperCase(); } catch (e) {}
    if (fromUrl && !/^[A-Z0-9][A-Z0-9_-]{1,39}$/.test(fromUrl)) fromUrl = '';
    if (fromUrl) { writeCookie(REF_COOKIE, fromUrl, 30); return fromUrl; }
    var fromCookie = readCookie(REF_COOKIE).trim().toUpperCase();
    return /^[A-Z0-9][A-Z0-9_-]{1,39}$/.test(fromCookie) ? fromCookie : '';
  })();
  var state = { me: null, rules: null, confirm: null, newCode: null, showAll: false, claim: null };

  function $(sel, el) { return (el || root).querySelector(sel); }
  function money(cents) { var d = cents / 100; return '$' + (d % 1 ? d.toFixed(2) : d.toFixed(0)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fmtDate(iso) { if (!iso) return ''; var d = new Date(iso.length === 10 ? iso + 'T12:00:00' : iso); return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' }); }
  function plural(n, w) { return n + ' ' + w + (n === 1 ? '' : 's'); }
  function icon(name) {
    var p = { info: 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm0 9a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1zm0-4a1.25 1.25 0 1 1 0 2.5A1.25 1.25 0 0 1 12 7z',
      check: 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm4.3 7.3-5 5a1 1 0 0 1-1.4 0l-2.2-2.2a1 1 0 1 1 1.4-1.4l1.5 1.5 4.3-4.3a1 1 0 0 1 1.4 1.4z',
      warn: 'M12 2 1 21h22L12 2zm0 6a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1zm0 9a1.25 1.25 0 1 1 0 2.5A1.25 1.25 0 0 1 12 17z' }[name];
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="' + p + '"/></svg>';
  }
  function note(kind, html) { return '<div class="rw-note is-' + kind + '" role="status">' + icon(kind === 'ok' ? 'check' : kind === 'err' || kind === 'warn' ? 'warn' : 'info') + '<div>' + html + '</div></div>'; }

  function api(path, opts) {
    opts = opts || {};
    var o = { method: opts.method || 'GET', headers: { 'Accept': 'application/json' }, credentials: 'same-origin' };
    if (opts.body) { o.headers['Content-Type'] = 'application/json'; o.body = JSON.stringify(opts.body); }
    return fetch(API + path + (path.indexOf('?') < 0 ? '?' : '&') + '_=' + Date.now(), o).then(function (r) {
      return r.text().then(function (t) { var j; try { j = JSON.parse(t); } catch (e) { j = { error: 'bad response' }; } j.__status = r.status; return j; });
    });
  }

  // ── rendering ────────────────────────────────────────────────────────────

  function railHtml(points, rules) {
    var fixed = rules.redeem.fixed_rewards.slice().sort(function (a, b) { return a.points - b.points; });
    var max = fixed.length ? fixed[fixed.length - 1].points : 100;
    var pct = function (p) { return Math.max(0, Math.min(100, p / max * 100)); };
    var you = pct(points);
    var h = '<div class="rw-rail" aria-hidden="true"><div class="rw-rail-track"></div><div class="rw-rail-fill" data-w="' + you + '"></div>';
    h += '<span class="rw-rail-t" style="left:0"><b>0</b></span>';
    fixed.forEach(function (r) {
      var on = points >= r.points;
      h += '<span class="rw-rail-stop' + (on ? ' is-on' : '') + '" style="left:' + pct(r.points) + '%"></span>';
      h += '<span class="rw-rail-t" style="left:' + pct(r.points) + '%"><b>' + r.points + '</b>' + money(r.value_cents) + '</span>';
    });
    var side = you < 6 ? ' is-left' : (you > 94 ? ' is-right' : '');
    h += '<span class="rw-rail-you" data-l="' + you + '"></span><span class="rw-rail-me' + side + '" data-l="' + you + '">' + points + '</span></div>';
    return h;
  }

  function heroIn(me, rules) {
    var worth = me.points >= rules.redeem.min_points ? Math.floor(Math.min(me.points, rules.redeem.max_points) / rules.redeem.points_per_dollar) : 0;
    var sub = worth > 0 ? 'points · worth up to <b>$' + worth + ' off</b>' : 'points · ' + (rules.redeem.min_points - me.points) + ' more to your first reward';
    var who = (me.first_name ? esc(me.first_name) + '<br>' : '') + (me.expires_at ? 'Expires <b>' + fmtDate(me.expires_at) + '</b>' : 'Points never expire while you shop');
    return '<div class="rw-hero" role="region" aria-label="Your points"><div class="rw-hero-top"><div class="rw-bal"><span class="rw-bal-n rw-num">' + me.points + '</span><span class="rw-bal-u">' + sub + '</span></div><div class="rw-hero-who">' + who + '</div></div>' + railHtml(me.points, rules) + '</div>';
  }

  function heroOut(rules) {
    var e = rules.earn;
    return '<div class="rw-hero is-out" role="region" aria-label="How rewards work"><div class="rw-bal"><span class="rw-bal-n">Earn ' + e.purchase_points_per_dollar + ' point per $1 on every order</span><span class="rw-bal-u">Points turn into discount codes: ' + rules.redeem.points_per_dollar + ' points is $1 off. Create an account and you start with ' + e.signup + ' points.</span></div>' +
      '<div class="rw-cta"><a class="rw-btn rw-btn-white" href="' + esc(LOGIN) + '?return_url=' + encodeURIComponent(RETURN) + '">Sign in</a><a class="rw-btn rw-btn-ghost" href="' + esc(REGISTER) + '">Create an account</a></div>' + railHtml(0, rules) + '</div>';
  }

  function redeemHtml(me, rules) {
    var fixed = rules.redeem.fixed_rewards.slice().sort(function (a, b) { return a.points - b.points; });
    var pts = me ? me.points : 0;
    var h = '<div class="rw-grid">';
    fixed.forEach(function (r) {
      var ok = me && pts >= r.points;
      var cond = r.min_subtotal_cents > 0 ? money(r.min_subtotal_cents) + '+ order' : 'any order';
      var p = ok ? plural(r.points, 'point') : (me ? r.points + ' points · ' + (r.points - pts) + ' to go' : plural(r.points, 'point'));
      h += '<div class="rw-tile' + (ok ? '' : ' is-locked') + '"><div><div class="rw-tile-v">' + money(r.value_cents) + ' off</div><div class="rw-tile-c">' + cond + '</div><div class="rw-tile-p">' + p + '</div></div>';
      h += me ? '<button class="rw-btn" type="button" data-redeem="' + esc(r.id) + '"' + (ok ? '' : ' disabled') + '>' + (ok ? 'Get code' : 'Locked') + '</button>' : '';
      h += '</div>';
    });
    h += '</div>';
    var step = rules.redeem.points_per_dollar, min = Math.ceil(rules.redeem.min_points / step) * step;
    var cap = me ? Math.min(pts, rules.redeem.max_points) : rules.redeem.max_points;
    var max = Math.floor(cap / step) * step;
    var can = me && max >= min;
    h += '<div class="rw-custom"><div class="rw-custom-h"><div><div class="rw-tile-v">Any amount</div><div class="rw-tile-c">' + step + ' points = $1 off, from ' + min + ' points</div></div></div>';
    if (me) {
      if (can && max > min) {
        var start = Math.max(min, Math.floor(Math.min(max, (min + max) / 2) / step) * step);
        var pct = ((start - min) / (max - min) * 100).toFixed(1);
        h += '<input type="range" min="' + min + '" max="' + max + '" step="' + step + '" value="' + start + '" style="--rw-pct:' + pct + '%" aria-label="Points to redeem" aria-valuetext="' + plural(start, 'point') + ', $' + (start / step) + ' off" data-custom-range>';
        h += '<div class="rw-custom-out"><b data-custom-dollars>$' + (start / step) + ' off</b><span data-custom-points>' + plural(start, 'point') + '</span></div>';
        h += '<button class="rw-btn" type="button" data-redeem-custom data-custom-fixed="' + start + '">Get code</button>';
      } else if (can) {
        h += '<div class="rw-custom-out"><b data-custom-dollars>$' + (max / step) + ' off</b><span data-custom-points>' + plural(max, 'point') + '</span></div>';
        h += '<button class="rw-btn" type="button" data-redeem-custom data-custom-fixed="' + max + '">Get code</button>';
      } else {
        h += '<div class="rw-custom-out"><span>' + (min - pts) + ' more points unlocks this</span></div><button class="rw-btn" type="button" disabled>Locked</button>';
      }
    }
    h += '</div><div class="rw-confirm" data-confirm aria-live="polite"></div>';
    return h;
  }

  function codesHtml(me) {
    if (!me) return '';
    var codes = me.open_codes || [];
    if (!codes.length && !state.newCode) return '<p class="rw-empty">No unused codes right now. Redeem points above and the code appears here, ready to apply.</p>';
    return codes.map(function (c) {
      var isNew = state.newCode === c.code;
      var cond = c.min_subtotal_cents > 0 ? money(c.min_subtotal_cents) + '+ order' : 'any order';
      return '<div class="rw-pass' + (isNew ? ' is-new' : '') + '"><div class="rw-pass-v">' + money(c.value_cents) + '</div><div class="rw-pass-d"><div class="rw-pass-code">' + esc(c.code) + '</div><div class="rw-pass-m">' + cond + ' · one use · ' + fmtDate(c.created_at) + '</div></div>' +
        '<div class="rw-pass-a"><a class="rw-btn" href="/discount/' + encodeURIComponent(c.code) + '?redirect=/collections/all">Apply</a><button class="rw-btn rw-btn-line" type="button" data-copy="' + esc(c.code) + '">Copy</button></div></div>';
    }).join('');
  }

  function earnHtml(rules) {
    var e = rules.earn;
    return '<div class="rw-earn"><div class="rw-earn-i"><b>' + e.purchase_points_per_dollar + '<small>pt</small></b>per $1 spent on any order</div>' +
      '<div class="rw-earn-i"><b>' + e.birthday + '</b>on your birthday, every year</div>' +
      (referralsOn(rules) ? '<div class="rw-earn-i"><b>' + e.referral + '</b>when a friend you refer places a first order, and they get ' + e.referral_friend_discount_percent + '% off</div>' : '') + '</div>';
  }

  function referralsOn(rules) { return !!(rules && rules.referrals_enabled !== false && rules.earn && rules.earn.referral > 0); }

  function referHtml(me, rules) {
    if (!referralsOn(rules)) return '';
    var link = me && me.referral_url;
    var h = '<div class="rw-box"><h3 class="rw-h3">Refer a friend</h3><p>Share your link. They get ' + rules.earn.referral_friend_discount_percent + '% off their first order, you get ' + plural(rules.earn.referral, 'point') + ' once it is paid.</p>';
    if (link) {
      h += '<div class="rw-field"><input type="text" readonly value="' + esc(link) + '" aria-label="Your referral link" data-ref-input><button class="rw-btn" type="button" data-copy="' + esc(link) + '">Copy link</button>' +
        '<a class="rw-btn rw-btn-line" href="mailto:?subject=' + encodeURIComponent('A movie deal for you') + '&body=' + encodeURIComponent('Grab a digital movie code and get ' + rules.earn.referral_friend_discount_percent + '% off your first order here: ' + link) + '">Email it</a></div>';
    } else if (!me) {
      h += '<div class="rw-field"><a class="rw-btn rw-btn-line" href="' + esc(LOGIN) + '?return_url=' + encodeURIComponent(RETURN) + '">Sign in to get your link</a></div>';
    }
    return h + '</div>';
  }

  function friendHtml(me, rules) {
    // The friend side of a referral: /pages/rewards?ref=CODE. One email field, no sign-in needed.
    var pct = rules.earn.referral_friend_discount_percent;
    if (me) return note('info', 'Referral links are for new customers, and you already have an account here. Your own link is under <b>Refer a friend</b> below.');
    var h = '<div class="rw-box rw-friend"><h3 class="rw-h3">A friend sent you ' + pct + '% off your first order</h3>';
    if (state.claim && state.claim.ok) {
      return h + note('ok', 'Done. Create an account with <b>' + esc(state.claim.email) + '</b> and your one-time ' + pct + '% code arrives by email within a minute. It is locked to that account.') +
        '<div class="rw-field"><a class="rw-btn" href="' + esc(REGISTER) + '">Create an account</a></div></div>';
    }
    h += '<p>Enter your email to claim it. The code is sent once you create an account with that address, and it works on your first paid order.</p>' +
      '<form class="rw-field" data-claim-form><input type="email" required autocomplete="email" inputmode="email" placeholder="you@example.com" aria-label="Your email" data-claim-email><button class="rw-btn" type="submit">Claim ' + pct + '% off</button></form>' +
      '<div data-claim-msg>' + (state.claim && state.claim.error ? note('err', esc(state.claim.error)) : '') + '</div></div>';
    return h;
  }

  function birthdayHtml(me, rules) {
    var h = '<div class="rw-box"><h3 class="rw-h3">Birthday points</h3>';
    if (!me) return h + '<p>' + plural(rules.earn.birthday, 'point') + ' on your birthday every year, once you add it to your account.</p></div>';
    if (me.birthday) return h + '<p>' + plural(rules.earn.birthday, 'point') + ' arrive every ' + fmtDate(me.birthday).replace(/,\s*\d{4}$/, '') + '.' + (me.birthday_next_award ? ' <span class="rw-note-inline">Next on ' + fmtDate(me.birthday_next_award) + '.</span>' : '') + '</p></div>';
    return h + '<p>Add your birthday and ' + plural(rules.earn.birthday, 'point') + ' arrive every year.</p><form class="rw-field" data-bday-form><input type="date" required aria-label="Your birthday" max="' + new Date().toISOString().slice(0, 10) + '" data-bday><button class="rw-btn" type="submit">Save</button></form><div data-bday-msg></div></div>';
  }

  var REASON = { order: 'Order', refund: 'Refund', signup: 'Welcome points', birthday: 'Birthday points', referral: 'Friend referred', redeem: 'Redeemed', redeem_cancel: 'Points returned', manual: 'Adjustment', import: 'Balance carried over', expiry: 'Points expired', social: 'Social follow or share' };
  function activityHtml(me) {
    if (!me) return '';
    var rows = me.history || [];
    if (!rows.length) return '<div class="rw-list"><p class="rw-empty">Nothing yet. Your first order starts the list.</p></div>';
    var shown = state.showAll ? rows : rows.slice(0, 8);
    var h = '<div class="rw-list">' + shown.map(function (r) {
      var title = REASON[r.reason] || r.reason;
      if (r.reason === 'order' && r.order_name) title = 'Order ' + esc(r.order_name);
      if (r.reason === 'refund' && r.order_name) title = 'Refund on ' + esc(r.order_name);
      if ((r.reason === 'redeem' || r.reason === 'redeem_cancel') && r.note) title += ' · ' + esc(r.note.split(' ')[0]);
      var sub = fmtDate(r.created_at) + (r.amount_cents && r.reason === 'order' ? ' · ' + money(r.amount_cents) + ' subtotal' : '') + (r.reason === 'manual' && r.note ? ' · ' + esc(r.note) : '');
      var d = r.delta;
      return '<div class="rw-item"><div class="rw-item-l">' + title + '<span class="rw-item-s">' + sub + '</span></div><span class="rw-delta rw-num ' + (d >= 0 ? 'is-plus' : 'is-minus') + '">' + (d >= 0 ? '+' : '−') + Math.abs(d) + '</span></div>';
    }).join('') + '</div>';
    if (!state.showAll && rows.length > 8) h += '<div class="rw-cta"><button class="rw-btn rw-btn-line" type="button" data-show-all>Show all ' + rows.length + '</button></div>';
    return h;
  }

  function expiryNote(me) {
    if (!me || !me.expires_at || me.points <= 0) return '';
    var days = Math.round((new Date(me.expires_at + 'T12:00:00') - new Date()) / 864e5);
    if (days > 30) return '';
    return note('warn', 'Your ' + plural(me.points, 'point') + ' expire on <b>' + fmtDate(me.expires_at) + '</b>. Any order or redemption keeps them for another year.');
  }

  function render() {
    var me = state.me, rules = state.rules;
    $('[data-slot=hero]').innerHTML = me ? heroIn(me, rules) : heroOut(rules);
    $('[data-slot=hero-note]').innerHTML = (REF && referralsOn(rules) ? friendHtml(me, rules) : '') + expiryNote(me) + (state.flash || '');
    $('[data-slot=redeem]').innerHTML = redeemHtml(me, rules);
    var codes = $('[data-slot=codes-wrap]');
    if (codes) { codes.style.display = me ? '' : 'none'; $('[data-slot=codes]').innerHTML = codesHtml(me); }
    $('[data-slot=earn]').innerHTML = earnHtml(rules);
    var refer = $('[data-slot=refer]'); refer.innerHTML = referHtml(me, rules); refer.style.display = refer.innerHTML ? '' : 'none';
    $('[data-slot=birthday]').innerHTML = birthdayHtml(me, rules);
    var act = $('[data-slot=activity-wrap]');
    if (act) { act.style.display = me ? '' : 'none'; $('[data-slot=activity]').innerHTML = activityHtml(me); }
    root.classList.remove('is-loading');
    requestAnimationFrame(function () {
      root.classList.add('is-ready');
      var fill = $('.rw-rail-fill'), you = $('.rw-rail-you'), me = $('.rw-rail-me');
      if (fill) fill.style.width = fill.getAttribute('data-w') + '%';
      if (you) you.style.left = you.getAttribute('data-l') + '%';
      if (me) me.style.left = me.getAttribute('data-l') + '%';
    });
  }

  // ── actions ──────────────────────────────────────────────────────────────

  function openConfirm(kind, payload, anchor) {
    var r = state.rules, box = $('[data-confirm]');
    // sit directly under what was tapped: after the tile (as a full grid row) or after the custom controls
    var tile = anchor && anchor.closest('.rw-tile');
    if (tile) tile.insertAdjacentElement('afterend', box); else $('.rw-custom').insertAdjacentElement('afterend', box);
    var pts, val, cond = 'any order';
    if (kind === 'fixed') { var fr = r.redeem.fixed_rewards.filter(function (x) { return x.id === payload; })[0]; pts = fr.points; val = fr.value_cents; cond = fr.min_subtotal_cents > 0 ? money(fr.min_subtotal_cents) + '+ order' : 'any order'; }
    else { pts = payload; val = Math.floor(pts / r.redeem.points_per_dollar) * 100; }
    state.confirm = { kind: kind, payload: payload };
    box.innerHTML = '<h3 class="rw-h3">Use ' + plural(pts, 'point') + ' for ' + money(val) + ' off?</h3><p>You get a single-use code for ' + money(val) + ' off ' + (cond === 'any order' ? 'any order' : 'a ' + cond) + '. It only works on your account and does not expire. Points come off your balance now.</p><div class="rw-cta"><button class="rw-btn" type="button" data-confirm-go>Yes, get my code</button><button class="rw-btn rw-btn-line" type="button" data-confirm-no>Not now</button></div><div data-confirm-msg></div>';
    box.classList.add('is-open');
    box.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    var go = $('[data-confirm-go]', box); if (go) go.focus();
  }

  function doRedeem() {
    var c = state.confirm; if (!c) return;
    var body = c.kind === 'fixed' ? { reward_id: c.payload } : { points: c.payload };
    var btn = $('[data-confirm-go]'); btn.classList.add('is-busy'); btn.textContent = 'Creating your code…';
    api('/redeem', { method: 'POST', body: body }).then(function (res) {
      var msg = $('[data-confirm-msg]');
      if (res.__status === 503) { msg.innerHTML = note('info', 'Redeeming opens on launch day. Your points are safe and this will work here.'); btn.classList.remove('is-busy'); btn.textContent = 'Yes, get my code'; return; }
      if (res.__status >= 400 || !res.code) { msg.innerHTML = note('err', esc(res.error || 'That did not go through. Nothing was taken from your balance. Try again in a moment.')); btn.classList.remove('is-busy'); btn.textContent = 'Yes, get my code'; return; }
      state.newCode = res.code;
      state.flash = note('ok', 'Your code <b>' + esc(res.code) + '</b> is saved under Your codes. Tap Apply and it goes straight onto your cart.');
      state.confirm = null;
      load().then(function () { showCodeDialog(res); });
    }).catch(function () { $('[data-confirm-msg]').innerHTML = note('err', 'No connection. Nothing was taken from your balance. Try again.'); btn.classList.remove('is-busy'); btn.textContent = 'Yes, get my code'; });
  }

  function showCodeDialog(res) {
    var cond = res.min_subtotal_cents > 0 ? 'a ' + money(res.min_subtotal_cents) + '+ order' : 'any order';
    var apply = '/discount/' + encodeURIComponent(res.code) + '?redirect=/collections/all';
    var dlg = $('.rw-dialog');
    if (!dlg) { dlg = document.createElement('dialog'); dlg.className = 'rw-dialog'; root.appendChild(dlg); }
    dlg.innerHTML = '<div class="rw-dialog-box" role="document">' +
      '<h3 class="rw-h3"><span class="rw-dialog-k">' + icon('check') + '</span>Your ' + money(res.value_cents) + ' off ' + cond + ' is ready</h3>' +
      '<div class="rw-dialog-code"><code data-code-text>' + esc(res.code) + '</code><button class="rw-btn rw-btn-line" type="button" data-copy="' + esc(res.code) + '">Copy</button></div>' +
      '<p class="rw-dialog-m">Use it once, on this account only. It never expires. <b>' + plural(res.points, 'point') + '</b> came off your balance; it is also saved under Your codes.</p>' +
      '<div class="rw-dialog-a"><a class="rw-btn" href="' + apply + '">Apply to cart</a><button class="rw-btn rw-btn-line" type="button" data-copy="' + esc(res.code) + '">Copy code</button><button class="rw-btn rw-btn-line" type="button" data-dialog-close>Done</button></div></div>';
    if (typeof dlg.showModal === 'function') {
      dlg.showModal();
      var w = $('[data-slot=codes-wrap]'); if (w) w.scrollIntoView({ block: 'start' });
    } else {
      var w2 = $('[data-slot=codes-wrap]'); if (w2) w2.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  }

  function copyText(text, btn) {
    var done = function () { var t = btn.textContent; btn.textContent = 'Copied'; setTimeout(function () { btn.textContent = t; }, 1500); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(done, function () { fallback(); });
    else fallback();
    function fallback() { var i = document.createElement('textarea'); i.value = text; document.body.appendChild(i); i.select(); try { document.execCommand('copy'); done(); } catch (e) {} document.body.removeChild(i); }
  }

  root.addEventListener('click', function (ev) {
    var t = ev.target.closest('[data-redeem],[data-redeem-custom],[data-copy],[data-confirm-go],[data-confirm-no],[data-show-all],[data-dialog-close]');
    if (!t) { if (ev.target.classList && ev.target.classList.contains('rw-dialog')) ev.target.close(); return; }
    if (t.hasAttribute('data-dialog-close')) { t.closest('dialog').close(); return; }
    if (t.hasAttribute('data-redeem')) openConfirm('fixed', t.getAttribute('data-redeem'), t);
    else if (t.hasAttribute('data-redeem-custom')) { var rng = $('[data-custom-range]'); openConfirm('custom', parseInt(rng ? rng.value : t.getAttribute('data-custom-fixed'), 10), t); }
    else if (t.hasAttribute('data-copy')) copyText(t.getAttribute('data-copy'), t);
    else if (t.hasAttribute('data-confirm-go')) doRedeem();
    else if (t.hasAttribute('data-confirm-no')) { state.confirm = null; $('[data-confirm]').classList.remove('is-open'); }
    else if (t.hasAttribute('data-show-all')) { state.showAll = true; $('[data-slot=activity]').innerHTML = activityHtml(state.me); }
  });
  root.addEventListener('input', function (ev) {
    if (!ev.target.hasAttribute('data-custom-range')) return;
    var v = parseInt(ev.target.value, 10), step = state.rules.redeem.points_per_dollar;
    var mn = parseInt(ev.target.min, 10), mx = parseInt(ev.target.max, 10);
    ev.target.style.setProperty('--rw-pct', ((v - mn) / (mx - mn) * 100).toFixed(1) + '%');
    ev.target.setAttribute('aria-valuetext', plural(v, 'point') + ', $' + (v / step) + ' off');
    $('[data-custom-dollars]').textContent = '$' + (v / step) + ' off';
    $('[data-custom-points]').textContent = plural(v, 'point');
  });
  root.addEventListener('submit', function (ev) {
    var cf = ev.target.closest('[data-claim-form]');
    if (cf) {
      ev.preventDefault();
      var email = $('[data-claim-email]', cf).value.trim(), btn = cf.querySelector('button');
      if (!email) return;
      btn.disabled = true;
      api('/referral/claim', { method: 'POST', body: { ref: REF, email: email } }).then(function (res) {
        btn.disabled = false;
        if (res.__status >= 400) { state.claim = { error: res.error || 'That did not work. Check the email address and try again.' }; }
        else { state.claim = { ok: true, email: email }; }
        render();
      });
      return;
    }
    var f = ev.target.closest('[data-bday-form]'); if (!f) return;
    ev.preventDefault();
    var v = $('[data-bday]', f).value, msg = $('[data-bday-msg]');
    if (!v) return;
    api('/birthday', { method: 'POST', body: { birthday: v } }).then(function (res) {
      if (res.__status >= 400) { msg.innerHTML = note('err', esc(res.error || 'Could not save that date.')); return; }
      state.flash = ''; load();
    });
  });

  function load() {
    return api('/me').then(function (res) {
      if (res.__status >= 400 || !res.rules && !res.points && res.points !== 0) throw new Error(res.error || 'load failed');
      if (res.logged_in === false || !LOGGED_IN) { state.me = null; state.rules = res.rules; }
      else { state.me = res; state.rules = state.rules || null; }
      if (!state.rules) return api('/config').then(function (r) { state.rules = r; render(); });
      render();
    }).catch(function () {
      root.classList.remove('is-loading');
      $('[data-slot=hero]').innerHTML = note('err', 'We could not load your points just now. Refresh the page or check back in a minute; nothing about your balance changes.');
    });
  }
  load();
})();
